<template>
    <div class="w-full d-flex justify-content-end position-relative shrink-0">
        <img
            class=" cursorPoint"
            :class="[iconSize==='s'?'size-s':'size-m']"
            src="@/assets/social-icon/new-fb.svg"
            alt="facebook icon"
            :data-ga-element="
                `${gaData}|分享至facebook`
            "
            @click="share('FB')"
        />
        <img
            class="ml-3 ml-md-2 ml-lg-3 cursorPoint"
            :class="[iconSize==='s'?'size-s':'size-m']"
            src="@/assets/social-icon/new-line.svg"
            alt="line icon"
            :data-ga-element="
                `${gaData}|分享至line`
            "
            @click="share('LINE')"
        />
        <img
            class="ml-3 ml-md-2 ml-lg-3 cursorPoint"
            :class="[iconSize==='s'?'size-s':'size-m']"
            src="@/assets/social-icon/new-link.svg"
            alt="copy-link icon"
            :data-ga-element="
                `${gaData}|拷貝連結`
            "
            @click="share('COPY')"
        />
        <CheckIcon
            v-if="copySuccess"
            size="1.75x"
            class="checkIcon"
             :class="[iconSize==='s'?'size-s':'size-m']"
            stroke-width="2"
        />
    </div>
</template>
<script>
import { shareLink } from '@/utils/Share';
import { CheckIcon } from 'vue-feather-icons';
export default {
    name: 'ShareButtons',
    components: { CheckIcon },
    props: {
        // s/m
        iconSize: {
            type: String,
            default: 's',
        },
        gaData: {
            type: String,
            default: '',
        },
        articleSeq: {
            type: String,
            default: '',
        },
        articleId: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            copySuccess: false
        };
    },
    methods: {
        async share(target) {
            const { copySuccess } = await shareLink(target, this.articleSeq, this.articleId);
            if (copySuccess) {
                this.copySuccess = copySuccess;
                setTimeout(() => {
                    this.copySuccess = false;
                }, 3000);
            }
        },
    }
};
</script>
<style scoped>
.shrink-0 {
    flex-shrink: 0;
}
.cursorPoint {
    cursor: pointer;
}
.size-s {
    width: 26px;
    height: 26px;
}
.size-m {
    width: 26px;
    height: 26px;
    @media (min-width: 400px) {
        width: 36px;
        height: 36px;
    }
    /* .checkIcon {
        width: 2rem;
        height: 2rem;
    } */
}
.checkIcon {
    /* width: 1.75rem;
    height: 1.75rem; */
    color: #ffc107;
    position: absolute;
    right: 0.1rem;
    top: 0rem;
    animation: scaleIn 0.35s ease-in-out alternate both;
    @include media-breakpoint-up(sm) {
        right: 1.5rem;
        top: 1.35rem;
    }
}
</style>
